/** Чистая логика карточек сравнения и списка монтажей (v2.1 §6.5, §6.7, §6.8). Без `@/`-импортов. */

/** Длительность ролика: 15000 → «15,0 с»; нет значения — «—». */
export function reelText(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return "—";
  return `${(ms / 1000).toLocaleString("ru-RU", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} с`;
}

/** Секунды человеческим языком: 13 → «13 с», 147 → «2 мин 27 с», 120 → «2 мин»; нет значения — «—». */
export function spanText(s: number | null | undefined): string {
  if (s === null || s === undefined || !Number.isFinite(s)) return "—";
  const total = Math.max(0, Math.round(s));
  const m = Math.floor(total / 60);
  const r = total % 60;
  if (m === 0) return `${r} с`;
  return r === 0 ? `${m} мин` : `${m} мин ${r} с`;
}

/** «сборка 13 с · генерация 2 мин 27 с» — обе подписи явные, даже если данных нет. */
export function timingText(renderSeconds: number | null, clipSeconds: number | null): string {
  return `сборка ${spanText(renderSeconds)} · генерация ${spanText(clipSeconds)}`;
}

/** Титр в списке монтажей: первая строка + «+1» (строк больше одной); пусто — `null`. */
export function titleSummary(title: string | null | undefined): { first: string; more: number } | null {
  const lines = (title ?? "").split("\n").map((x) => x.trim()).filter(Boolean);
  if (lines.length === 0) return null;
  return { first: lines[0]!, more: lines.length - 1 };
}

/** Тайл хронологии рисует картинку только при непустом пути стилла. */
export function hasStill(still: { asset_path: string } | null | undefined): boolean {
  return Boolean(still && still.asset_path);
}
